import React from "react";
import Button from "shared/components/Button";
import { Container, Row } from "reactstrap";

const ButtonComponent = () => {
  return (
    <Container>
      <Row style={{ justifyContent: "space-evenly" }}>
        <Button type="primary" label="Primary" />
        <Button type="disabled" label="Disabled" />
        <Button type="primary" label="Add" icon="add" />
      </Row>
    </Container>
  );
};

export default ButtonComponent;
